export default __webpack_public_path__ + "static/media/img7.615a3d2f.png";